import React from 'react';
import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { AssociatedPersonsSection } from './components/sections/associated-persons-section';
import { LocationsSection } from './components/sections/locations-section';
import { NearbyLocationsSection } from './components/sections/nearby-locations-section';
import { observer } from 'mobx-react-lite';
import { useEventAssociatedPersonsQuery } from '../../event-state/use-event-associated-persons-query';
import { useEventLocationCautionsQuery } from '../../event-state/use-event-location-cautions-query';

export const CautionsTab = observer(function CautionsTab() {
    const eventId = useWorkspacePanel().linkedEntityId;

    const eventAssociatedPersonsQuery = useEventAssociatedPersonsQuery({ eventId });
    const eventLocationCautionsQuery = useEventLocationCautionsQuery({ eventId });

    return (
        <EventPanelTab title="Cautions">
            <TabBody>
                <LocationsSection
                    data={eventLocationCautionsQuery.data?.wholeAddressCautionTabLocation}
                    isLoading={eventLocationCautionsQuery.isFetching}
                />
                <NearbyLocationsSection
                    data={eventLocationCautionsQuery.data?.nearbyCautionTabLocations}
                    isLoading={eventLocationCautionsQuery.isFetching}
                />
                <AssociatedPersonsSection
                    data={eventAssociatedPersonsQuery.data}
                    isLoading={eventAssociatedPersonsQuery.isFetching}
                />
            </TabBody>
        </EventPanelTab>
    );
});
